<template>
  <section id="compliance-monitor">
    <h5 class="is-size-5">
      <i>
        La solución de Monitoreo de Cumplimiento de Ceptinel proporciona un
        sistema eficiente de detección de casos de AML, Financiamiento de
        Terrorismo y Abuso de mercado a través de monitoreo de datos.
      </i>
    </h5>
    <img src="@/assets/cepSuites/banner-cumplimiento.jpg" alt="cumplimiento" />
    <p>
      Ceptinel puede detectar como ejemplo uso de información privilegiada de
      personas con acceso a datos sensibles, operaciones bursátiles en períodos
      de blackout, y alertas de Volcker-Rule.
      <br />
      Permite cruzar información de transacciones de un operador y un cliente,
      personas relacionadas con información privilegiada, personas o entidades
      en listas negras, etc.
      <br />
      El sistema detecta los casos en etapas iniciales, generando alertas de
      forma batch o en tiempo real.
      <br />
      Ceptinel ha logrado detectar múltiples casos de abuso o AML, evitando que
      el cliente tenga altas pérdidas por robos y corrupción interna así como la
      recepción de multas del regulador.
      <br />
      Evita situaciones que podrían generar un impacto reputacional negativo
      mucho mayor aún que las propias multas.
      <br />
      Permite dejar logs de auditoría, tanto para investigaciones posteriores
      como para demostrar debida diligencia al regulador Precisa, con
      implementación rápida y costo muy competitivo.
    </p>
    <br />
    <h5 class="is-size-5">Como Funciona</h5>
    <p>
      Se aplica reglas de negocio a través del Editor de reglas gráfico del
      sistema, generando alertas, listas y reportes. Tanto reglas propias
      propuestas por Ceptinel, como configurando reglas específicas de la
      empresam
    </p>
    <br />
    <h5 class="is-size-5">Competencia</h5>
    <p>
      Las soluciones actuales son de costo mayor y ofrecen un nivel de
      flexibilidad más limitado en su workflow, donde cada modificación
      posterior a las reglas pre-definidas resulta costoso y demoroso
    </p>
    <br />
    <h4>¿Porqué hoy es tan importante?</h4>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Con un volumen de datos creciendo en forma exponencial, los equipos de
      cumplimiento tienen que enfrentarse con el desafío de detectar los casos
      de AML, abuso de mercado y cumplimiento normativo que son difíciles de
      hallar mediante métodos y reportes tradicionales o se encuentran cuando es
      demasiado tarde.
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Hoy las multas del regulador en casos que no se detecta AML y ATF son cada
      vez mayores, incluyendo presidio
    </p>
    <h4>Características:</h4>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Editor de reglas gráfico
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Reglas automatizadas y customizables
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Múltiples fuentes de datos con fácil conexión e integración
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Generación de alertas e informes
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Detección de anomalías con Machine Learning
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Log de Auditoría
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Análisis de Documentos
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Agenda Normativa
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Canal de denuncias automatizada
    </p>
    <p>
      <i class="fas fa-caret-right has-text-primary"></i>
      Alternativa Cloud o On-Premise
    </p>
  </section>
</template>
<script>
export default {
  name: "compliance-monitor",
};
</script>